import React, { memo } from 'react';

import View from '@/components/atomic/atoms/layout/view/styled';
import ModelPageRenderer from '@/components/atomic/atoms/utils/model-page-renderer';
import { useDropdownMocks } from '@/hooks/use-dropdown-mocks';
import usePageModel from '@/hooks/use-page-model';
import useStore from '@/state';
import getDropdownSegment from '@/state/selectors/navigation/get-dropdown-segment';
import { IStore } from '@/state/slices/typings';

const DesktopMenuContainer: React.FC = () => {
	const fragmentVariationPath = useStore((state: IStore) =>
		getDropdownSegment(state, 1),
	);

	const mockedModel = useDropdownMocks(fragmentVariationPath);

	const pageModel = usePageModel(
		fragmentVariationPath,
		undefined,
		mockedModel,
	);

	return (
		<View $width='100%'>
			<ModelPageRenderer
				fragmentVariationPath={fragmentVariationPath}
				mockedModel={pageModel ?? undefined}
			/>
		</View>
	);
};

export default memo(DesktopMenuContainer);
